import CourseController from './course.controller';
import { ResizeObserver } from '@juggle/resize-observer';

export default class FrameworkCourseController extends CourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $scope);
    Object.assign(this, { $timeout });
    this.diagramId = this.diagramService.guid();
  }

  $onInit() {
    if (this.setPyramidData) {
      this.bindScrollForPyramidBuilderData();
      // handling page resize
      const ro = new ResizeObserver(() => {
        this.bindScrollForPyramidBuilderData();
      });
      ro.observe(document.querySelector('.unit'));
    }
    super.$onInit()
  }

  bindScrollForPyramidBuilderData() {
    try {
      const offSetTop = $(`#${this.exerciseId}`).offset().top;
      const halfOfWindowScreen = $(window).height() / 2;
      $(window).off(`scroll.${this.exerciseId}`);
      $(window).on(`scroll.${this.exerciseId}`, () => {
        if (window.scrollY + halfOfWindowScreen >= offSetTop) {
          this.setPyramidData({$event: this.pyramidData});
        }
      });
    } catch (e) {

    }
  }

  $postLink() {
    setTimeout(() => {
      if (this.isCompleted[this.clearDiagramId]) return;
      this.diagramService.initSCQDiagram(this.diagramId, true, this.first)
    }, 1000)
  }

  $onDestroy() {
    this.diagramService.clearScrollHandler();
  }

  // second param is for don't call wrongAnswer sound if we called method from hint
  submit(pyramidData, callNotFromHint = true) {
    callNotFromHint && this.submitCount++;
    const boxesWithIncorectAnswers = $(`#${this.diagramId} .answer__incorrect`);
    const boxesWithCorectAnswers = $(`#${this.diagramId} .answer__correct`);
    this.submited = true;
    if (boxesWithCorectAnswers.length === this.amountCorrectAnswers) {
    // if (true) {
      this.courseService.play('buttonClick');
      this.diagramComplete = true;
      this.diagramService.disableSCQDiagram(this.diagramId);
      if (!this.scqDiagram) {
        setTimeout(() => {
          this.courseService.play('exerciseComplete');
        }, 1000);
        this.$timeout(() => {
          pyramidData.model = {
            attempts: this.submitCount,
            hintsUsed: this.hintCount,
            rightAnswers: 1
          }
          this.onSubmit({ $event: pyramidData });
        }, 1000);
      }
    } else if (callNotFromHint) {
      this.courseService.play('wrongAnswer');
    }

  }

  hint(callChildSubmit = false, childSubmitFunc) {
    this.hintCount++;
    this.courseService.play('buttonClick');

    const selector = `#${this.diagramId} .answer__incorrect`;
    const elements = $(selector).toArray();
    if (!elements.length) {
      if (callChildSubmit && childSubmitFunc) {
        childSubmitFunc(false)
      } else if (this.isFiveSection) {
        this.submit(this.pyramidData, false)
      }
    }
    const simpleSeparatop = [];
    const solutionSeparatop = [];

    elements.forEach((element) => {
      const parentBlock = $( element ).parent();
      const simpleSeparator = parentBlock.find('.simple-separator')[0];
      const solutionSeparator = parentBlock.find('.solution-separator')[0];

      if (simpleSeparator) {
        simpleSeparatop.push(simpleSeparator);
      } else if (solutionSeparator) {
        solutionSeparatop.push([...$(solutionSeparator).children().toArray()]);
      }
    });

    elements.forEach((slot) => {
      if ($( slot ).hasClass('r1-block__top-part')) {
        $( slot ).css({'border-color': 'red red transparent red', 'z-index': '6'});
      } else if ($( slot ).hasClass('r1-block__bottom-part')) {
        $( slot ).css({'border-color': 'transparent red red red', 'z-index': '6'});
      } else {
        $( slot ).css({'border-color': 'red', 'z-index': '6'});
      }
    });

    $(simpleSeparatop).css({'border-color': 'red', 'z-index': '6'});

    solutionSeparatop.forEach((line) => {
      if ($( line ).hasClass('top-line')) {
        $( line ).css({'background-image': 'linear-gradient(to right, red 50%, rgba(255, 255, 255, 0) 0%)', 'z-index': '6'});
      } else {
        $( line ).css({'background-image': 'linear-gradient(to right, red 65%, rgba(255, 255, 255, 0) 0%)', 'z-index': '6'});
      }
    });

    setTimeout(() => {
      $( simpleSeparatop ).attr('style', '');
      $( elements ).attr('style', '');
      solutionSeparatop.forEach((line) => {
        $( line ).attr('style', '');
      });
    }, 200);
  }

}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/framework-course.controller.js